<div class="bg-blue-800 text-white text-left px-8 py-16 text-3xl rounded-b-md">
    Fiche Ecart
  </div>
<mat-accordion class="example-headers-align">
    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" fxLayout="column" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="font-bold">
            <mat-icon>indeterminate_check_box</mat-icon> Ecart
        </mat-panel-title>
        <mat-panel-description>
          Remplir votre ecart
          <mat-icon>format_list_bulleted</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <mat-card>
        <app-recherche
        [api]="generalService.api"
        [numColonneToShow]="1"
        [numColonneToReturn]='0'
        recherche="API_SourceEcart"
        (ChampEnter)="blurEcart()"
        placeholder="Source ecart"
        
      >
      </app-recherche>
      <unilog-recherche
        
        appearance="legacy"
        (ChampEnter)="blurEcart()"
        champsAffiche="QActionTypeLibelle"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        recherche="API_SourceEcart"
        [api]="generalService.api"
        placeholder="ecart"
     
      >
      </unilog-recherche>
      <div fxLayout="row" fxLayoutAlign="start none">
      <mat-form-field appearance="legacy">
        <mat-label>Source</mat-label>
        <input matInput>
      </mat-form-field>
  
      <mat-form-field appearance="legacy">
        <mat-label>Type Action</mat-label>
        <input matInput>
      </mat-form-field>
      <app-recherche
      [api]="generalService.api"
      [numColonneToShow]="0"
      [numColonneToReturn]='0'
      recherche="API_TypeAction"

      placeholder="Type action"
      
    >
    </app-recherche>

      <mat-form-field appearance="legacy">
        <mat-label>Processus</mat-label>
        <input matInput>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start none">
      <mat-form-field appearance="legacy">
        <mat-label>Désigniation</mat-label>
        <input matInput>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="35">
        <mat-label>Description</mat-label>
        <textarea matInput></textarea>
      </mat-form-field>
    </div>
    </mat-card>
      <mat-action-row>
        <button mat-button color="primary" (click)="nextStep()">Next</button>
      </mat-action-row>
    </mat-expansion-panel>
  
    <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="font-bold">
            <mat-icon>indeterminate_check_box</mat-icon> Actions immédiates
        </mat-panel-title>
        <mat-panel-description>
          Consulter votre actions immédiates
          <mat-icon>bookmark</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      
      <div fxLayout="row" fxLayoutAlign="start none">
      <button (click)="clickTShowCard()" mat-mini-fab color="primary" aria-label="Example icon button with a menu icon" style="left: 17px;">
        <mat-icon>menu</mat-icon>
      </button>

      <div fxFlex="20"></div>
    <mat-card *ngIf="clicked" [class]="clicked ? 'm-fadeIn' : 'm-fadeOut'">
        <mat-card-header style="justify-content: flex-end;" >
          
                <mat-icon (click)="clickToHideCard()" >close</mat-icon>
             
        </mat-card-header>
        <mat-form-field appearance="legacy">
          <mat-label>Action</mat-label>
          <input matInput>
        </mat-form-field>
    
        <mat-form-field appearance="legacy">
          <mat-label>Responsable</mat-label>
          <input matInput>
        </mat-form-field>
    
        <mat-card-actions>
            <button  mat-mini-fab  aria-label="Example icon button with a menu icon" style="justify-content: flex-start;">
                <mat-icon>add</mat-icon>
              </button>
        </mat-card-actions>
       
    </mat-card>
      </div>
  
    
      <div class="text-gray-700 text-xl px-8 font-bold">Liste des actions immédiates</div>
      <mat-card>
      <div class="shadow overflow-hidden rounded border-b border-gray-200">
        <table class="w-full bg-white">
          <thead class="bg-gray-800 text-white">
            <tr>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Actions
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Responsable
              </th>
            
            </tr>
          </thead>
          <tbody class="text-gray-700">
            <tr>
              <td class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">113</td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card>
  
      <mat-action-row>
        <button mat-button color="warn" (click)="prevStep()">Previous</button>
        <button mat-button color="primary" (click)="nextStep()">Next</button>
      </mat-action-row>
    </mat-expansion-panel>
  
    <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
      <mat-expansion-panel-header (click)="selectCause('close')">
        
        <mat-panel-title class="font-bold"><mat-icon>indeterminate_check_box</mat-icon>
          Analyse
        </mat-panel-title>
        <mat-panel-description>
          Consulter votre analyse des causes
          <mat-icon>map</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <mat-card>
      <div class="shadow overflow-hidden rounded border-b border-gray-200 " >
        <table class="w-full bg-white">
          <thead class="bg-gray-800 text-white">
            <tr>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Cause
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Type
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Origine
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Action
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Cloture
              </th>
              <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                Taux efficacité
              </th>
            
            </tr>
          </thead>
          <tbody class="text-gray-700">
            <tr>
              <td (click)="selectCause('open')" class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">
                test
              </td>
              <td class="text-left py-3 px-16">
                test
              </td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </mat-card>
      <mat-action-row>
        <button mat-button color="warn" (click)="prevStep()">Previous</button>
        <button mat-button color="primary" (click)="nextStep()">Next</button>
      </mat-action-row>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)" fxLayout="column" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="font-bold">
            <mat-icon>indeterminate_check_box</mat-icon> Cloture
        </mat-panel-title>
        <mat-panel-description>
          Remplir votre cloture
          <mat-icon>format_list_bulleted</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <mat-card>
      <div fxLayout="row" fxLayoutAlign="start center">

          <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="1">Cloturée</mat-radio-button>
            <mat-radio-button value="2">Non Cloturée</mat-radio-button>
          </mat-radio-group>

    </div>
    <br>
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy">
        <mat-label>Date cloture</mat-label>
        <input matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="40">
        <mat-label>Rapport cloture</mat-label>
        <textarea rows="6" matInput></textarea>
      </mat-form-field>
    </div>
    </mat-card>
      <mat-action-row>
        <button mat-button color="warn" (click)="prevStep()">Previous</button>
        <button mat-button color="primary" (click)="nextStep()">End</button>
      </mat-action-row>
    </mat-expansion-panel>
  
  </mat-accordion>


  



  <div class="flex justify-center w-full p-10 bg-gray-100" id="data" *ngIf="openTest">
    <div
      class="rounded-md shadow-md p-16 w-10/12 flex flex-col gap-2 border bg-white"
    >
      <div class="text-3xl text-center">
        Détail cause
      </div>
      
      <hr class="my-4" />
      <div class="flex justify-between mr-5">
        <div class="grid">
          <mat-form-field appearance="legacy">
            <mat-label>cause</mat-label>
            <input matInput>
          </mat-form-field>
        </div>
        <div class="grid">
          <mat-form-field appearance="legacy">
            <mat-label>type</mat-label>
            <input matInput>
          </mat-form-field>
        </div>
        <div class="grid">
          <mat-form-field appearance="legacy">
            <mat-label>origine</mat-label>
            <input matInput>
          </mat-form-field>
        </div>
      </div>
      <hr class="my-4" />
    
      <div class="grid">
        <div class="text-gray-700 text-xl px-8 font-bold">Plan d'actions</div>
        <div class="shadow overflow-hidden rounded border-b border-gray-200 " >
          <table class="w-full bg-white">
            <thead class="bg-gray-800 text-white">
              <tr>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Code
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Désigniation
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Détail
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Responsable réalisation
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Taux réalisation
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Commentaires
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Date réalisation
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Taux efficacité
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Rapport efficacité
                </th>
                <th class="text-left py-3 px-16 uppercase font-semibold text-sm">
                  Délai suivi
                </th>
              
              </tr>
            </thead>
            <tbody class="text-gray-700">
              <tr>
                <td (click)="selectCause('open')" class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                <td class="text-left py-3 px-16">
                  test
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
     
    </div>
  </div>
  